'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchArticle = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _types = require('./types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultArticleState = function defaultArticleState() {
    return {
        title: {},
        section: {},
        changes: {},
        components: []
    };
};

/* eslint-disable import/prefer-default-export */
var fetchArticle = exports.fetchArticle = function fetchArticle() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultArticleState();
    var action = arguments[1];

    if (action.type === _types.ARTICLE_SUCCESS) {
        return action.payload;
    }

    if (action.type === _types.ARTICLE_FAILURE) {
        return (0, _extends3.default)({}, state, action.payload, {
            error: true
        });
    }

    return state;
};
/* eslint-enable import/prefer-default-export */
//# sourceMappingURL=reducers.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/redux-article/lib/cjs/reducers.js
 ** module id = 547
 ** module chunks = 1
 **/